<div class="icon-container">
  <app-icon class="icon-icon" icon="backpack" />
</div>
<div class="message">
  <span class="message-title">{{ gameNames[content.game] }} @if (content.type === 'open') { is open } @else { has started }</span>
  <div class="message-content">
    <app-icon icon="coin" [width]="14"></app-icon>
    <app-currency [value]="content.amount" [size]="14"></app-currency>

    @if (content.game === 'casebattles') {
    <span>|</span>
    <span>{{ content.rounds }} rounds</span>
    }
  </div>
</div>
<div class="end-col">
  <button class="button" [ngClass]="content.type === 'open' ? 'green' : 'red'" (click)="watchGame()">
    {{ content.type === 'open' ? 'Join' : 'Watch' }}
  </button>
</div>
